module.exports = __webpack_public_path__ + "static/media/computing.db940c34.jpg";